import "../../static/Hexa.css";
import env from "react-dotenv";
import { useState, useEffect } from "react";
const Hexagon = ({ param }) => {
    const [width, SetWidth] = useState(null);
    console.log(width);
    const tet = "#36383E";
    const pri = "#EEE7E1"

    const BH = env.REACT_APP_ENV === "PROD" ? env.REACT_APP_BH_PROD : env.REACT_APP_BH_DEV;

    useEffect(() => {
        SetWidth((document.getElementsByTagName("body")[0].offsetWidth < document.getElementsByTagName("body")[0].offsetHeight) ? document.getElementsByTagName("body")[0].offsetWidth: document.getElementsByTagName("body")[0].offsetHeight/2.2);
    },[width]);
    return (
        <div style={{ backgroundColor: "white", width: "100%", minHeight: width * 1.5, display: "grid", gridTemplateColumns: "30% 70%" }} id="hexa">

            <div style={{ background: "linear-gradient(45deg, wheat, " + pri + ")", width: "100%", minHeight: width * 1.5 }} className="AlignBodies">
                <div style={{ background: tet }} className="Center Vertically Horizontally">
                    <img src={BH + param.userData.candidate.picture} style={{ width: width / 6 + "px", height: width / 6 + "px", borderRadius: "50%" }} alt={param.userData.candidate.picture}/>

                </div>
                <div>
                    <div className="Triangle" style={{ borderLeft: width / 7.5 + "px solid transparent", borderRight: width / 7.5 + "px solid transparent", borderTop: width / 20 + "px solid #36383E" }}>

                    </div>

                    <div style={{ padding: width / 50 }}>
                        <div>
                            <span style={{ fontSize: width / 40, fontWeight: "700" }}>

                                Contact Details
                            </span>
                        </div>

                        <div style={{ marginTop: width / 100 }}>
                            {
                                //contact details
                            }
                            <div className="ContactInner" style={{ fontSize: width / 50, paddingTop: width / 100 }} >
                                <div className="Center Horizontally Vertically" style={{ backgroundColor: tet, width: width / 40, height: width / 40, borderRadius: "50%" }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width={width / 60} height={width / 60} fill="white" class="bi bi-envelope-fill" viewBox="0 0 16 16">
                                        <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
                                    </svg>
                                </div>
                                <div>

                                    {param.userData.candidate.email}
                                </div>
                            </div>

                            <div className="ContactInner" style={{ fontSize: width / 50, paddingTop: width / 100 }}>
                                <div className="Center Horizontally Vertically" style={{ backgroundColor: tet, width: width / 40, height: width / 40, borderRadius: "50%" }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width={width / 60} height={width / 60} fill="white" class="bi bi-telephone-fill" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                    </svg>

                                </div>
                                <div>

                                    {param.userData.candidate.phone_number}
                                </div>
                            </div>

                            <div className="ContactInner" style={{ fontSize: width / 50, paddingTop: width / 100 }}>
                                <div className="Center Horizontally Vertically" style={{ backgroundColor: tet, width: width / 40, height: width / 40, borderRadius: "50%" }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width={width / 60} height={width / 60} fill="white" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">

                                        <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                                    </svg>
                                </div>
                                <div>
                                    <span>
                                        {param.userData.candidate.address}
                                    </span>
                                    &nbsp;
                                    <span>
                                        {param.userData.candidate.address_cont}

                                    </span>

                                </div>

                            </div>

                        </div>
                    </div>

                    {
                        // Education
                    }
                    <div style={{ padding: width / 50 }}>
                        <div>
                            <span style={{ fontSize: width / 40, fontWeight: "700" }}>

                                Education
                            </span>
                        </div>

                        <div style={{ marginTop: width / 100 }}>
                            {
                                param.userData.education.map((item, index) =>

                                    <div key={index} style={{ display: "grid", gridTemplateColumns: "15% 85%" }}>
                                        <div className="Center Horizontally" style={{ gridTemplateRows: "1% 99%", width: "100%" }}>
                                            <div style={{ width: width / 100, height: width / 100, background: tet, borderRadius: "50%" }}>

                                            </div>


                                            <div style={{ width: width / 400, height: "100%", background: tet, marginLeft: "30%" }}>

                                            </div>


                                        </div>

                                        <div style={{ marginBottom: width / 100 }}>
                                            <div style={{ paddingTop: width / 200, fontSize: width / 45, fontWeight: "700" }}>
                                                {item['degree_name']}
                                            </div>
                                            <div style={{ paddingTop: width / 200, fontSize: width / 45 }}>
                                                {item['school_name']}
                                            </div>
                                            <div style={{ paddingTop: width / 200, fontSize: width / 45 }}>
                                                {item['start_date'].substring(0, 4)} - {item['graduation_date'].substring(0, 4)}
                                            </div>
                                            <div style={{ paddingTop: width / 200, fontSize: width / 45 }}>
                                                {item['grading']}
                                            </div>
                                        </div>
                                    </div>

                                )
                            }
                        </div>
                    </div>

                    {
                        //SKILLS
                    }

                    <div style={{ padding: width / 50 }}>
                        <div>
                            <span style={{ fontSize: width / 40, fontWeight: "700" }}>

                                Skills
                            </span>
                        </div>

                        <div style={{ marginTop: width / 100 }}>
                            {
                                param.userData.skills.map((item, index) =>
                                    <div key={index} style={{ marginTop: -width / 50 }}>
                                        <span style={{ fontSize: width / 55 }} >
                                            {item['name']}
                                        </span>
                                    </div>
                                )
                            }
                        </div>
                    </div>


                    {
                        //Languages
                    }

                    <div style={{ padding: width / 50, height: "100%" }}>
                        <div>
                            <span style={{ fontSize: width / 40, fontWeight: "700" }}>
                                Languages
                            </span>
                        </div>

                        <div style={{ marginTop: width / 100 }}>
                            {
                                param.userData.languages.map((item, index) =>
                                    <div key={index} style={{ marginTop: -width / 50 }}>
                                        <span style={{ fontSize: width / 55 }} >
                                            {item['name']}
                                        </span>
                                    </div>
                                )
                            }
                        </div>
                    </div>


                </div>

            </div>

            <div className="AlignBodies" style={{ minHeight: width * 1.5, backgroundColor: "white" }}>
                <div style={{ background: tet, paddingLeft: width / 20 + "px" }} className="Center Vertically">
                    <p style={{ textTransform: "capitalize" }}>
                        <span style={{ color: 'white', fontSize: width / 25 }}>
                            {param.userData.candidate.first_name} {param.userData.candidate.last_name}
                        </span>
                        <br />
                        <span style={{ color: 'white', fontSize: width / 50 }}>
                            {param.userData.candidate.job_role}
                        </span>


                    </p>
                </div>

                <div style={{ marginTop: width / 17, padding: width / 50 }}>
                    {
                        //  Summary
                    }
                    <div>

                        <div style={{ borderBottom: "1px solid " + tet }}>
                            <span style={{ fontSize: width / 40, fontWeight: "700" }}>
                                Summary
                            </span>
                        </div>
                        <div style={{ lineHeight: width / 500 }}>
                            <span style={{ fontSize: width / 60 + "px" }}>
                                {param.userData.candidate.summary}
                            </span>
                        </div>
                    </div>

                    {
                        // work experience
                    }

                    <div style={{ marginTop: width / 100 }}>
                        <div style={{ borderBottom: "1px solid " + tet }}>
                            <span style={{ fontSize: width / 40 }}>
                                Work Experience
                            </span>
                        </div>

                        <div>
                            {
                                param.userData.work_exps.map((item, index) =>
                                    <div key={index} style={{ marginTop: width / 100 }}>
                                        <div style={{ lineHeight: width / 600 }}>
                                            <span style={{ fontSize: width / 50, fontWeight: "700" }}>{item['title']}, {item['company']} - {item['country']}</span><br />
                                            <span style={{ fontWeight: "100", fontSize: width / 50, color: "gray" }}>{item['date_start'].substring(0, 4)} - {item['is_current'] ? "Present" : item['date_end'].substring(0, 4)}</span>

                                        </div>

                                        {
                                            //key res
                                        }
                                        <div style={{ marginTop: width / 100 }}>
                                            {
                                                item['keyRes'].map((res, index) =>
                                                    <div key={index} style={{ display: "grid", gridTemplateColumns: "10% 90%" }}>
                                                        <div style={{ backgroundColor: tet, width: width / 100, height: width / 100, borderRadius: "50%", alignSelf: "flex-start", marginTop: width / 100 }}>

                                                        </div>

                                                        <div style={{ fontSize: width / 50 }}>
                                                            {res}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>

                    {
                        // References
                    }

                    <div style={{ marginTop: width / 100 }}>
                        <div style={{ borderBottom: "1px solid " + tet }}>
                            <span style={{ fontSize: width / 40 }}>
                                References
                            </span>
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "50% 50%" }}>
                            {
                                param.userData.refs.map((item, index) =>
                                    <div key={index} style={{ lineHeight: width / 500 }}>
                                        <span style={{ fontSize: width / 50 }}>
                                            <span style={{ fontWeight: "600" }}>{item['full_name']} </span><br />{item['address']}<br />{item['phone_number']}<br />{item['email']}
                                        </span>
                                    </div>
                                )
                            }
                        </div>

                    </div>
                </div>


            </div>


        </div>
    )

}

export default Hexagon;